import { z } from "zod";

// Audit-fact events for the site lifecycle. Sites are not (yet) an event-sourced
// aggregate with their own read-model projection — these exist so the audit
// trail is derived from the log instead of direct writes to audit_events.
export const siteCreated = z.object({
  type: z.literal("SiteCreated"),
  siteId: z.string().min(1),
  name: z.string(),
  status: z.string(),
});

export const siteUpdated = z.object({
  type: z.literal("SiteUpdated"),
  siteId: z.string().min(1),
  name: z.string().nullable().optional(),
  geofenceDistance: z.number().nullable().optional(),
});

export const siteDeactivated = z.object({
  type: z.literal("SiteDeactivated"),
  siteId: z.string().min(1),
  status: z.string().default("inactive"),
});

export const siteReactivated = z.object({
  type: z.literal("SiteReactivated"),
  siteId: z.string().min(1),
  status: z.string().default("active"),
});

export const siteInviteSent = z.object({
  type: z.literal("SiteInviteSent"),
  siteId: z.string().min(1),
  email: z.string(),
  role: z.string(),
  delivery: z.string().nullable().optional(),
});

export const siteDeleted = z.object({
  type: z.literal("SiteDeleted"),
  siteId: z.string().min(1),
});

export const siteEvents = [
  siteCreated,
  siteUpdated,
  siteDeactivated,
  siteReactivated,
  siteInviteSent,
  siteDeleted,
] as const;
